<template>
  <hb-basic-page
    :action-buttons="actionButtons"
    :back-button="{ show: true, fallback: 'tenant_surveys' }"
    :loading="loading"
    :subtle-loading="subtleLoading"
    :title="$t('surveys.create_survey')"
    name="create-survey-view"
  >
    <v-col class="mb-10" cols="12" lg="6" md="8" offset-lg="3" offset-md="2" offset-xl="3" xl="6">
      <create-survey ref="createSurvey" :loading="loading" @validation-errors="handleValidationErrors"/>
    </v-col>

    <template v-if="validationErrors" v-slot:bottom-bar-help>
      <span class="caption">
        <v-icon color="error" size="20" style="margin-top: -2px">mdi mdi-alert</v-icon>
        {{ $t('surveys.errors.validation_errors') }}
      </span>
    </template>
  </hb-basic-page>
</template>

<script>
import CreateSurvey from '@/components/Tenant/CreateSurvey/CreateSurvey';

export default {
  name: 'CreateSurveyView',
  components: {CreateSurvey},
  data() {
    return {
      loading: true,
      subtleLoading: false,
      validationErrors: false,
      actionButtons: {
        cancel: {
          text: this.$t('cancel'),
          icon: 'arrow_back',
          callback: this.cancel,
          primary: false,
        },
        save: {
          text: this.$t('save'),
          icon: 'mdi mdi-check',
          callback: this.saveSurvey,
          primary: true,
          loading: false,
        },
      },
    };
  },
  methods: {
    handleValidationErrors(val) {
      this.validationErrors = val;
    },
    async saveSurvey() {

      if (this.actionButtons?.save) {
        this.actionButtons.save.loading = true;
      }
      if (this.actionButtons?.cancel) {
        this.actionButtons.cancel.loading = true;
      }

      await this.$refs.createSurvey.saveSurvey();
      if (this.actionButtons?.save) {
        this.actionButtons.save.loading = false;
      }
      if (this.actionButtons?.cancel) {
        this.actionButtons.cancel.loading = false;
      }

    },
    cancel() {
      this.$router.go(-1);
    },
  },
  mounted() {
    if (!this.$hasMatchingTenantRoles(['tenant_admin'])) {
      this.$router.replace({name: 'access_denied'});
      return;
    }
    this.loading = false;
  },
};
</script>
